import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@convex/_generated/dataModel";
import { PlayerHistoryScreen } from "@/features/night/players/PlayerHistoryScreen";

type PlayerHistorySearch = {
  from?: "draft" | "profile";
};

export const Route = createFileRoute("/_authenticated/leagues/$leagueId/players/$playerId_/history")(
  {
    validateSearch: (search: Record<string, unknown>): PlayerHistorySearch =>
      search.from === "draft" || search.from === "profile" ? { from: search.from } : {},
    component: LeaguePlayerHistoryPage,
  },
);

function LeaguePlayerHistoryPage() {
  const { leagueId, playerId } = Route.useParams();
  const { from } = Route.useSearch();

  return (
    <PlayerHistoryScreen
      leagueId={leagueId as Id<"leagues">}
      playerId={playerId as Id<"players">}
      {...(from ? { from } : {})}
    />
  );
}
